const actions = {
  CREATE_MEMBER: 'CREATE_MEMBER',
  CREATE_MEMBER_ENDED: 'CREATE_MEMBER_ENDED',
  LOCK_MEMBER: 'LOCK_MEMBER',
  LOCK_MEMBER_ENDED: 'LOCK_MEMBER_ENDED',
  UNLOCK_MEMBER: 'UNLOCK_MEMBER',
  UNLOCK_MEMBER_ENDED: 'UNLOCK_MEMBER_ENDED',
  DEACTIVATE_MEMBER: 'DEACTIVATE_MEMBER',
  DEACTIVATE_MEMBER_ENDED: 'DEACTIVATE_MEMBER_ENDED',
  SEARCH_MEMBERS: 'SEARCH_MEMBERS',
  SEARCH_MEMBERS_ENDED: 'SEARCH_MEMBERS_ENDED',
  FIND_MEMBER: 'FIND_MEMBER',
  FIND_MEMBER_ENDED: 'FIND_MEMBER_ENDED',
  UPDATE_MEMBER: 'UPDATE_MEMBER',
  UPDATE_MEMBER_ENDED: 'UPDATE_MEMBER_ENDED',
  GET_MEMBERSHIP_LEVEL_OF_MEMBER: 'GET_MEMBERSHIP_LEVEL_OF_MEMBER',
  GET_MEMBERSHIP_LEVEL_OF_MEMBER_ENDED: 'GET_MEMBERSHIP_LEVEL_OF_MEMBER_ENDED',
  GET_TAG_OF_MEMBER: 'GET_TAG_OF_MEMBER',
  GET_TAG_OF_MEMBER_ENDED: 'GET_TAG_OF_MEMBER_ENDED',
  GET_MEMBER_POINT_BALANCE_OF_MEMBER: 'GET_MEMBER_POINT_BALANCE_OF_MEMBER',
  GET_MEMBER_POINT_BALANCE_OF_MEMBER_ENDED: 'GET_MEMBER_POINT_BALANCE_OF_MEMBER_ENDED',
  ADJUST_MEMBERSHIP_LEVEL: 'ADJUST_MEMBERSHIP_LEVEL',
  ADJUST_MEMBERSHIP_LEVEL_ENDED: 'ADJUST_MEMBERSHIP_LEVEL_ENDED',
  SEARCH_MEMBER_ATTRIBUTES: 'SEARCH_MEMBER_ATTRIBUTES',
  SEARCH_MEMBER_ATTRIBUTES_ENDED: 'SEARCH_MEMBER_ATTRIBUTES_ENDED',
  FIND_MEMBER_ATTRIBUTE: 'FIND_MEMBER_ATTRIBUTE',
  FIND_MEMBER_ATTRIBUTE_ENDED: 'FIND_MEMBER_ATTRIBUTE_ENDED',
  UPDATE_MEMBER_ATTRIBUTE: 'UPDATE_MEMBER_ATTRIBUTE',
  UPDATE_MEMBER_ATTRIBUTE_ENDED: 'UPDATE_MEMBER_ATTRIBUTE_ENDED',
  UNMASK_PROFILE: 'UNMASK_PROFILE',
  UNMASK_PROFILE_ENDED: 'UNMASK_PROFILE_ENDED',
};

export default actions;
